import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BuildingStatus } from '../land/state'
import { initialCastle5State, Castle5State } from './state'

export const castle5Slice = createSlice({
  name: 'castle5',
  initialState: initialCastle5State as Castle5State,
  reducers: {
    setCastle5Loading: (state: Castle5State, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setCastle5ImmediateLoading: (state: Castle5State, action: PayloadAction<boolean>) => {
      state.isImmediate = action.payload
    },
    setCastle5Error: (state: Castle5State, action: PayloadAction<string | undefined>) => {
      state.error = action.payload
    },
    setCastle5BuildingStatus: (state: Castle5State, action: PayloadAction<Partial<BuildingStatus>>) => {
      const existingStatus = state.buildingStatus || initialCastle5State.buildingStatus
      const payload = action.payload
      
      const mergedStatus = { ...existingStatus } as Partial<BuildingStatus>
      
      for (const key in payload) {
        if (payload[key as keyof BuildingStatus]) {
          const existingBuilding = existingStatus[key as keyof BuildingStatus]
          const payloadBuilding = payload[key as keyof BuildingStatus]
          if (existingBuilding) {
            mergedStatus[key as keyof BuildingStatus] = {
              ...existingBuilding,
              ...payloadBuilding,
              hp: Number(payloadBuilding?.hp ?? 0),
              maxHp: Number(payloadBuilding?.maxHp ?? 0),
            } as any
          } else {
            mergedStatus[key as keyof BuildingStatus] = {
              ...payloadBuilding,
              hp: Number(payloadBuilding?.hp ?? 0),
              maxHp: Number(payloadBuilding?.maxHp ?? 0),
            } as any
          }
        }
      }
      
      state.buildingStatus = mergedStatus
    },
    setCastle5RepairRequirements: (state: Castle5State, action: PayloadAction<{ ecsToken: number; gem: number; stone: number; wood: number }>) => {
      state.repairRequirements = action.payload
    },
    setCastle5RestoreBuilding: (state: Castle5State) => {
      state.isRestored = true
    },
    setCastle5FetchSupportCharacters: (state: Castle5State, action: PayloadAction<any[]>) => {
      state.supportCharacters = action.payload
    },
    setCastle5SupportCharacters: (state: Castle5State, action: PayloadAction<any[]>) => {
      state.supportCharacters = [...state.supportCharacters, ...action.payload]
      state.isSetSupportCharacterSuccess = true
    },
    setCastle5ClearStatus: (state: Castle5State) => {
      state.isSetSupportCharacterSuccess = false
      state.error = undefined
    },
    setCastle5SupportState: (state: Castle5State, action: PayloadAction<boolean>) => {
      state.supportState = action.payload
    },
    setCastle5UpgradeBuilding: (state: Castle5State) => {
      state.upgradeAvailable = false
    },
    setCastle5UpgradeRequirements: (state: Castle5State, action: PayloadAction<{ ecsToken: number }>) => {
      state.upgradeRequirements = action.payload
    },
    setCastle5UpgradeAvailable: (state: Castle5State, action: PayloadAction<boolean>) => {
      state.upgradeAvailable = action.payload
    },
    setCastle5RemoveCharacterFromBuilding: (state: Castle5State, action: PayloadAction<{ success: boolean; building: string; character: string }>) => {
      // Handle character removal if needed
    },
    setCastle5AddCharacterToBuilding: (state: Castle5State, action: PayloadAction<{ success: boolean; building: string; character: string }>) => {
      // Handle character addition if needed
    },
    setCastle5AllMiningStatus: (state: Castle5State, action: PayloadAction<any>) => {
      state.allMiningStatus = action.payload
    },
  },
})

export const {
  setCastle5Loading,
  setCastle5ImmediateLoading,
  setCastle5Error,
  setCastle5BuildingStatus,
  setCastle5RepairRequirements,
  setCastle5RestoreBuilding,
  setCastle5FetchSupportCharacters,
  setCastle5SupportCharacters,
  setCastle5ClearStatus,
  setCastle5SupportState,
  setCastle5UpgradeBuilding,
  setCastle5UpgradeRequirements,
  setCastle5UpgradeAvailable,
  setCastle5RemoveCharacterFromBuilding,
  setCastle5AddCharacterToBuilding,
  setCastle5AllMiningStatus,
} = castle5Slice.actions

export default castle5Slice.reducer
